import React from 'react';
import { motion } from 'framer-motion';

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const CTA = () => {
  return (
    <motion.section
      className="bg-blue-600 text-white py-16 text-center"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
    >
      <div className="max-w-3xl mx-auto px-4">
        <motion.h2
          className="text-3xl md:text-4xl font-bold mb-4"
          variants={fadeInUp}
          custom={0}
        >
          Ready to Transform Your WhatsApp Marketing?
        </motion.h2>

        <motion.p
          className="mb-6 text-lg"
          variants={fadeInUp}
          custom={1}
        >
          Start engaging with your customers in a smarter way — with personalized, automated WhatsApp campaigns.
        </motion.p>

        <motion.a
          href="https://wa.me/919558213879"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white text-blue-600 font-semibold py-3 px-6 rounded-lg hover:bg-blue-100 transition"
          variants={fadeInUp}
          custom={2}
          whileHover={{ scale: 1.05 }}
        >
          Get Started on WhatsApp
        </motion.a>
      </div>
    </motion.section>
  );
};

export default CTA;
